import { DateTime } from 'luxon';

import Styles from './styles.module.scss';

interface Props {
	text: string;
}

export const TimeCell = ({ text }: Props) => {
	const formattedTime = text ? DateTime.fromISO(text).toFormat('EEE, dd LLL - HH:mm') : '';
	return (
		<div className={Styles.timeCellContainer}>
			<span>{formattedTime}</span>
		</div>
	);
};
